import { render, staticRenderFns } from "./BoardCardsBusiness.vue?vue&type=template&id=160ab917&"
import script from "./BoardCardsBusiness.vue?vue&type=script&lang=js&"
export * from "./BoardCardsBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports